<template>
  <div class="not-find">
    <div class="not-find__wrp">
      <div class="not-find__content">
        <p class="not-find__text">
          {{ _T("@Nothing was found for your request") }}
        </p>
        <p class="not-find__text">
          {{ _T("@Use the tips for a successful search") }}
        </p>
        <ul class="not-find__prompt-list">
          <li
            v-for="(item, index) in promptItem"
            :key="index"
            class="not-find__prompt-item"
          >
            <span class="not-find__num">{{ index + 1 }}</span>
            <p class="not-find__text">
              {{ _T(item) }}
            </p>
          </li>
        </ul>
        <ButtonLink class="not-find__btn" name="catalog">
          {{ _T("@Catalog") }}
        </ButtonLink>
      </div>
      <div class="not-find__img-wrp">
        <img src="/img/empty-search.png" alt="sad cat" loading="lazy" />
      </div>
    </div>
  </div>
</template>

<script setup>
import ButtonLink from "~/modules/shared/buttons/ButtonLink.vue";

const promptItem = [
  "@Try searching by product type",
  "@Check the spelling of keywords",
  "@Expand your search query",
];
</script>

<style lang="scss" scoped>
.not-find {
  height: 100dvh;

  padding: 0 16px 100px;

  &__wrp {
    @extend %width-main;

    @include flex-container(row, space-between, flex-start);

    margin: 0 auto;
    gap: 16px;

    @include bigMobile {
      @include flex-container(column, space-between, flex-start);
    }
  }

  &__content {
    max-width: 525px;
    width: 100%;

    @include flex-container(column, flex-start, flex-start);

    gap: 16px;

    @include bigMobile {
      max-width: 100%;
    }
  }

  &__result {
    @include font(28, 39, 600);
    letter-spacing: 0.02em;

    @include mobile {
      @include font(18, 22, 600);
    }
  }

  &__text,
  &__num {
    @include font(16, 24, 400);
    letter-spacing: 0.02em;

    @include mobile {
      @include font(14, 21, 400);
    }
  }

  &__num {
    color: var(--color-primary-base);
  }

  &__prompt-list {
    @include flex-container(column, flex-start, flex-start);

    gap: 8px;
  }

  &__prompt-item {
    @include flex-container(row, flex-start, baseline);

    gap: 8px;
  }

  &__img-wrp {
    max-width: 600px;
    width: 100%;

    @include flex-container(row, flex-end, center);

    border-bottom: 3px solid #393d38;

    @include bigMobile {
      max-width: 100%;

      @include flex-container(row, center, center);
    }
  }

  &__btn {
    max-width: 236px;
    width: 100%;

    @include mobile {
      max-width: 100%;
    }
  }
}
</style>
